<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ (asset_type.id ? 'Edit ' : 'Create ') + assetTypeLabel() }}</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #form="ngForm" (ngSubmit)="onSubmit(form, !asset_type.id)">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Name</mat-label>
      <input
        matInput
        placeholder="Name"
        [(ngModel)]="asset_type.name"
        name="name"
        type="text"
        required
        #name />
      <mat-hint>Please enter a {{ assetTypeLabel() }} name.</mat-hint>
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Description</mat-label>
      <textarea
        rows="4"
        matInput
        placeholder="Description"
        [(ngModel)]="asset_type.description"
        name="description"
        #description>
      </textarea>
      <mat-hint>Please enter a short description for the {{ assetTypeLabel() }}.</mat-hint>
    </mat-form-field>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="px-3 py-2">

    <button
      mat-raised-button
      [disabled]="!form.valid || inProgress"
      color="primary"
      type="submit"
      class="my-2 ml-1 mr-2"
      id="save">
      <mat-icon>save</mat-icon>
      Save
    </button>

    <button
      type="button"
      color="warn"
      class="dialog-remove-button my-2 ml-auto mr-1"
      mat-icon-button
      [disabled]="!asset_type.id"
      (click)="onDelete()"
      [matTooltip]="'Archive this ' + assetTypeLabel()">
      <mat-icon>archive</mat-icon>
    </button>

  </mat-dialog-actions>

</form>

